"use client";

import { useMotionValueEvent, useScroll } from "motion/react";
import * as motion from "motion/react-m";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

import { ChanhDaiMark } from "./chanhdai-mark";

export function SiteHeaderMark() {
  const pathname = usePathname();
  return pathname === "/" ? <ChanhDaiMarkMotion /> : <ChanhDaiMark />;
}

function ChanhDaiMarkMotion() {
  const { scrollY } = useScroll();
  const [visible, setVisible] = useState(false);
  const distanceRef = useRef(160);

  useMotionValueEvent(scrollY, "change", (latestValue) => {
    setVisible(latestValue >= distanceRef.current);
  });

  useEffect(() => {
    const coverMark = document.getElementById("js-cover-mark");
    if (!coverMark) return;

    distanceRef.current = calcDistance(coverMark);

    const resizeObserver = new ResizeObserver(() => {
      distanceRef.current = calcDistance(coverMark);
    });
    resizeObserver.observe(coverMark);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <>
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120 48"
        className="block dark:hidden"
        initial={{
          opacity: 0,
          transform: "translateY(8px)",
        }}
        animate={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0px)" : "translateY(8px)",
        }}
        transition={{ duration: 0.3 }}
      >
        <text
          x="60"
          y="36"
          fontFamily="Arial, sans-serif"
          fontSize="32"
          fontWeight="bold"
          textAnchor="middle"
          fill="black"
        >
          RJ
        </text>
      </motion.svg>
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120 48"
        className="hidden dark:block"
        initial={{
          opacity: 0,
          transform: "translateY(8px)",
        }}
        animate={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0px)" : "translateY(8px)",
        }}
        transition={{ duration: 0.3 }}
      >
        <text
          x="60"
          y="36"
          fontFamily="Arial, sans-serif"
          fontSize="32"
          fontWeight="bold"
          textAnchor="middle"
          fill="white"
        >
          RJ
        </text>
      </motion.svg>
    </>
  );
}

const calcDistance = (el: HTMLElement) => {
  const rect = el.getBoundingClientRect();
  const scrollTop = document.documentElement.scrollTop;
  const headerHeight = 56;
  return scrollTop + rect.top + rect.height - headerHeight;
};
